import { Field, Label } from "./catalyst/fieldset";

export const ReadOnlyFormElement: React.FC<any> = ({ label, value }) => {
  return (
    <Field>
      <Label style={{fontSize:'13px'}}>{label}</Label>
      <div className="text-gray-800 dark:text-gray-200">{value}</div>
    </Field>
  );
};
